import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@nx-fe/pipes';
import { SvgErrorImageComponent } from './svg-error-image/svg-error-image.component';
import { SvgFetchDataErrorComponent } from './svg-fetch-data-error/svg-fetch-data-error.component';
import { SvgIconAddNewComponent } from './svg-icon-add-new/svg-icon-add-new.component';
import { SvgIconAllSmartBatteries } from './svg-icon-allsmartbatteries/svg-icon-allsmartbatteries.component';
import { SvgIconAppComponent } from './svg-icon-app/svg-icon-app.component';
import { SvgIconApplicationListComponent } from './svg-icon-application-list/svg-icon-application-list.component';
import { SvgIconApplicationShift } from './svg-icon-application-shift/svg-icon-application-shift.component';
import { SvgIconApplication } from './svg-icon-application/svg-icon-application.component';
import { SvgIconArrowComponent } from './svg-icon-arrow/svg-icon-arrow.component';
import { SvgIconBatterySummary } from './svg-icon-batterysummary/svg-icon-batterysummary.component';
import { SvgIconCalendar } from './svg-icon-calendar/svg-icon-calendar.component';
import { SvgIconCallAction } from './svg-icon-call-action/svg-icon-call-action.component';
import { SvgIconCallCloseFullScreenComponent } from './svg-icon-call-close-fullscreen/svg-icon-call-close-fullscreen-action.component';
import { SvgIconCallFailed } from './svg-icon-call-failed/svg-icon-call-failed.component';
import { SvgIconCallFullScreenComponent } from './svg-icon-call-fullscreen/svg-icon-call-fullscreen-action.component';
import { SvgIconCallHangupComponent } from './svg-icon-call-hangup-action/svg-icon-call-hangup-action.component';
import { SvgIconCallHoldOffComponent } from './svg-icon-call-hold-off-action/svg-icon-call-hold-off-action.component';
import { SvgIconCallHoldOnComponent } from './svg-icon-call-hold-on-action/svg-icon-call-hold-on-action.component';
import { SvgIconCallRejected } from './svg-icon-call-rejected/svg-icon-call-rejected.component';
import { SvgIconCancelSquareComponent } from './svg-icon-cancel-square/svg-icon-cancel-square.component';
import { SvgIconChartsDemoPage } from './svg-icon-charts-demo-page/svg-icon-charts-demo-page.component';
import { SvgIconCharts } from './svg-icon-charts/svg-icon-charts.component.';
import { SvgIconChatActionComponent } from './svg-icon-chat-action/svg-icon-chat-action.component';
import { SvgIconChatNavigationComponent } from './svg-icon-chat-navigation/svg-icon-chat-navigation.component';
import { SvgIconArrowDownComponent } from './svg-icon-arrow-down/svg-icon-arrow-down.component';
import { SvgIconChatNofiticationActionComponent } from './svg-icon-chat-nofitication-action/svg-icon-chat-nofitication-action.component';
import { SvgIconChatSendMessageComponent } from './svg-icon-chat-send-message/svg-icon-chat-send-message.component';
import { SvgIconChatTitleComponent } from './svg-icon-chat-title/svg-icon-chat-title.component';
import { SvgIconChatComponent } from './svg-icon-chat/svg-icon-chat.component';
import { SvgIconCheckIn } from './svg-icon-check-in/svg-icon-check-in.component';
import { SvgIconClockComponent } from './svg-icon-clock/svg-icon-clock.component';
import { SvgIconCloseChatNotificationAction } from './svg-icon-close-chat-notification-action/svg-icon-close-chat-notification-action.component';
import { SvgIconClose } from './svg-icon-close/svg-icon-close.component';
import { SvgIconCog } from './svg-icon-cog/svg-icon-cog.component';
import { SvgIconColumnViewComponent } from './svg-icon-column-view/svg-icon-column-view.component';
import { SvgIconConfigError } from './svg-icon-config-error/svg-icon-config-error.component';
import { SvgIconCopyComponent } from './svg-icon-copy/svg-icon-copy.component';
import { SvgIconCreateIncidentAction } from './svg-icon-create-incident-action/svg-icon-create-incident-action.component';
import { SvgIconCsv } from './svg-icon-csv/svg-icon-csv.component';
import { SvgIconDeleteComponent } from './svg-icon-delete/svg-icon-delete.component';
import { SvgIconDesktopActiveComponent } from './svg-icon-desktop-active/svg-icon-desktop-active.component';
import { SvgIconDesktopInactiveComponent } from './svg-icon-desktop-inactive/svg-icon-desktop-inactive.component';
import { SvgIconDeviceAndroidActiveTableComponent } from './svg-icon-device-android-active-table/svg-icon-device-android-active-table.component';
import { SvgIconDeviceAndroidActiveWhiteComponent } from './svg-icon-device-android-active-white/svg-icon-device-android-active-white.component';
import { SvgIconDeviceAndroidActiveComponent } from './svg-icon-device-android-active/svg-icon-device-android-active.component';
import { SvgIconDeviceAndroidInactiveComponent } from './svg-icon-device-android-inactive/svg-icon-device-android-inactive.component';
import { SvgIconBatteryUsage } from './svg-icon-device-batteryusage/svg-icon-device-batteryusage.component';
import { SvgIconDeviceBusy } from './svg-icon-device-busy/svg-icon-device-busy.component';
import { SvgIconDataUsage } from './svg-icon-device-datausage/svg-icon-device-datausage.component';
import { SvgIconLastKnownLocation } from './svg-icon-device-lastknown/svg-icon-device-lastknown.component';
import { SvgIconDeviceNetworkComponent } from './svg-icon-device-network/svg-icon-device-network.component';
import { SvgIconSignalStrength } from './svg-icon-device-signalstrength/svg-icon-device-signalstrength.component';
import { SvgIconDeviceUserNotSpeaking } from './svg-icon-device-user-not-speaking/svg-icon-device-user-not-speaking.component';
import { SvgIconDeviceUserSpeaking } from './svg-icon-device-user-speaking/svg-icon-device-user-speaking.component';
import { SvgIconDeviceUserAction } from './svg-icon-device-user/svg-icon-device-user.component';
import { SvgIconDeviceWebAppComponent } from './svg-icon-device-web-app/svg-icon-device-web-app.component';
import { SvgIconDeviceWifi } from './svg-icon-device-wifi/svg-icon-device-wifi.component';
import { SvgIconDeviceAndroidForWork } from './svg-icon-deviceAndroidForWork/svg-icon-deviceAndroidForWork.component';
import { SvgIconDeviceAndroidOpaqueComponent } from './svg-icon-deviceAndroidOpaque/svg-icon-deviceAndroidOpaque.component';
import { SvgIconDeviceId } from './svg-icon-deviceId/svg-icon-deviceId.component';
import { SvgIconDeviceList } from './svg-icon-devicelist/svg-icon-devicelist.component';
import { SvgIconDocumentComponent } from './svg-icon-document/svg-icon-document.component';
import { SvgIconDownloadDarkComponent } from './svg-icon-download-dark/svg-icon-download-dark.component';
import { SvgIconDownloadLightComponent } from './svg-icon-download-light/svg-icon-download-light.component';
import { SvgIconDropdown } from './svg-icon-dropdown/svg-icon-dropdown.component';
import { SvgIconEditComponent } from './svg-icon-edit/svg-icon-edit.component';
import { SvgIconEndChatAction } from './svg-icon-end-chat-action/svg-icon-end-chat-action.component';
import { SvgIconEndSessionComponent } from './svg-icon-end-session/svg-icon-end-session.component';
import { SvgIconEnlargeComponent } from './svg-icon-enlarge/svg-icon-enlarge.component';
import { SvgIconHelpComponent } from './svg-icon-help/svg-icon-help.component';
import { SvgIconHoldAndCallComponent } from './svg-icon-hold-and-call/svg-icon-hold-and-call.component';
import { SvgIconDeviceDecommission } from './svg-icon-icon-decommission/svg-icon-icon-decommission.component';
import { SvgIconDeviceRecommission } from './svg-icon-icon-recommission/svg-icon-icon-recommission.component';
import { SvgIconIMDeleteNewComponent } from './svg-icon-imdelete-new/svg-icon-imdelete-new.component';
import { SvgIconInfoComponent } from './svg-icon-info/svg-icon-info.component';
import { SvgIconLinkComponent } from './svg-icon-link/svg-icon-link.component';
import { SvgIconManageShiftComponent } from './svg-icon-manage-shift/svg-icon-manage-shift.component';
import { SvgIconMessageNotDelivered } from './svg-icon-message-not-delivered/svg-icon-message-not-delivered.component';
import { SvgIconMicOffActionComponent } from './svg-icon-mic-off-action/svg-icon-mic-off-action.component';
import { SvgIconMicOffComponent } from './svg-icon-mic-off/svg-icon-mic-off.component';
import { SvgIconMicOnActionComponent } from './svg-icon-mic-on-action/svg-icon-mic-on-action.component';
import { SvgIconMicOnComponent } from './svg-icon-mic-on/svg-icon-mic-on.component';
import { SvgIconMinimize } from './svg-icon-minimize/svg-icon-minimize.component';
import { SvgIconMinusComponent } from './svg-icon-minus/svg-icon-minus.component';
import { SvgIconMoreComponent } from './svg-icon-more/svg-icon-more.component';
import { SvgIconMoreChatComponent } from './svg-icon-more-chat/svg-icon-more-chat.component';
import { SvgIconNewRemoteControl } from './svg-icon-newRemoteControl/svg-icon-newRemoteControl.component';
import { SvgIconNewTicket } from './svg-icon-newTicket/svg-icon-newTicket.component';
import { SvgIconNoDataAddedComponent } from './svg-icon-no-data-added/svg-icon-no-data-added.component';
import { SvgIconNoMapFoundComponent } from './svg-icon-no-map-found/svg-icon-no-map-found';
import { SvgIconPauseVideoComponent } from './svg-icon-pause-video/svg-icon-pause-video.component';
import { SvgIconPhoneCallAction } from './svg-icon-phone-call-action/svg-icon-phone-call-action.component';
import { SvgIconRcAction } from './svg-icon-rc-action/svg-icon-rc-action.component';
import { SvgIconRefreshComponent } from './svg-icon-refresh/svg-icon-refresh.component';
import { SvgIconRemoteControl } from './svg-icon-remoteControl/svg-icon-remoteControl.component';
import { SvgIconSbImportComponent } from './svg-icon-sb-import/svg-icon-sb-import.component';
import { SvgIconScreenOffComponent } from './svg-icon-screen-off-action/svg-icon-screen-off-action.component';
import { SvgIconScreenOnComponent } from './svg-icon-screen-on-action/svg-icon-screen-on-action.component';
import { SvgIconSearchComponent } from './svg-icon-search/svg-icon-search.component';
import { SvgIconTestConnectionComponent } from './svg-icon-test-connection/svg-icon-test-connection';
import { SvgIconTextComponent } from './svg-icon-text/svg-icon-text.component';
import { SvgIconVideoCallComponent } from './svg-icon-video-call-action/svg-icon-video-call-action.component';
import { SvgIconVideoOffActionComponent } from './svg-icon-video-off-action/svg-icon-video-off-action.component';
import { SvgIconVideoOffComponent } from './svg-icon-video-off/svg-icon-video-off.component';
import { SvgIconVideoOnActionComponent } from './svg-icon-video-on-action/svg-icon-video-on-action.component';
import { SvgIconVideoOnComponent } from './svg-icon-video-on/svg-icon-video-on.component';
import { SvgIconVideoComponent } from './svg-icon-video/svg-icon-video.component';
import { SvgIconVoiceCallComponent } from './svg-icon-voice-call/svg-icon-voice-call.component';
import { SvgIconVoiceComponent } from './svg-icon-voice/svg-icon-voice.component';
import { SvgIconWarning } from './svg-icon-warning/svg-icon-warning.component';
import { SvgIconWatchList } from './svg-icon-watchlist/svg-icon-watchlist.component';
import { SvgIconWebAppListComponent } from './svg-icon-web-app-list/svg-icon-web-app-list.component';
import { SvgIconWebAppComponent } from './svg-icon-web-app/svg-icon-web-app.component';
import { SvgIconWifiComponent } from './svg-icon-wifi/svg-icon-wifi.component';
import { SvgIconXsightWelcome } from './svg-icon-xsight-welcome/svg-icon-xsight-welcome.component';
import { SvgOnboardingIconComponent } from './svg-onboarding-icon/svg-onboarding-icon.component';
import { SvgSotixsightHorizontalLogoComponent } from './svg-sotixsight-horizontal-logo/svg-sotixsight-horizontal-logo.component';
import { SvgIconAddConditionComponent } from './svg-icon-add-condition/svg-icon-add-condition.component';
import { SvgIconDeviceWindowsActiveComponent } from './svg-icon-device-windows-active/svg-icon-device-windows-active';
import { SvgIconDeviceWindowsInactiveComponent } from './svg-icon-device-windows-inactive/svg-icon-device-windows-inactive';

export { SvgIconCopyComponent, SvgIconDeleteComponent, SvgIconEditComponent, SvgIconTestConnectionComponent };

@NgModule({
  imports: [CommonModule, PipesModule],
  declarations: [
    SvgIconAddConditionComponent,
    SvgIconArrowComponent,
    SvgIconAppComponent,
    SvgIconApplication,
    SvgIconAllSmartBatteries,
    SvgIconDataUsage,
    SvgIconBatteryUsage,
    SvgIconLastKnownLocation,
    SvgIconSignalStrength,
    SvgIconDeviceWifi,
    SvgIconDeviceList,
    SvgIconDropdown,
    SvgIconCalendar,
    SvgIconWatchList,
    SvgIconCharts,
    SvgIconCog,
    SvgIconRemoteControl,
    SvgIconNewRemoteControl,
    SvgIconNewTicket,
    SvgIconDeviceAndroidOpaqueComponent,
    SvgIconDeviceAndroidForWork,
    SvgIconDeviceId,
    SvgIconManageShiftComponent,
    SvgIconMessageNotDelivered,
    SvgIconCheckIn,
    SvgIconDeviceDecommission,
    SvgIconDeviceRecommission,
    SvgIconSbImportComponent,
    SvgIconCsv,
    SvgIconDeviceAndroidActiveComponent,
    SvgIconDeviceAndroidInactiveComponent,
    SvgIconDeviceAndroidActiveWhiteComponent,
    SvgIconCsv,
    SvgIconBatterySummary,
    SvgIconClose,
    SvgIconCallAction,
    SvgIconCallFailed,
    SvgIconVideoCallComponent,
    SvgIconRcAction,
    SvgIconCreateIncidentAction,
    SvgIconEndChatAction,
    SvgIconChatTitleComponent,
    SvgIconChatActionComponent,
    SvgIconArrowDownComponent,
    SvgIconChatNofiticationActionComponent,
    SvgIconMicOffActionComponent,
    SvgIconMicOnActionComponent,
    SvgIconMinimize,
    SvgIconVideoOnActionComponent,
    SvgIconVideoOffActionComponent,
    SvgIconScreenOnComponent,
    SvgIconScreenOffComponent,
    SvgIconCallHoldOffComponent,
    SvgIconCallHoldOnComponent,
    SvgIconCallHangupComponent,
    SvgIconCallFullScreenComponent,
    SvgIconCallCloseFullScreenComponent,
    SvgIconCallRejected,
    SvgIconDeviceUserAction,
    SvgIconDeviceUserNotSpeaking,
    SvgIconDeviceUserSpeaking,
    SvgIconChatSendMessageComponent,
    SvgErrorImageComponent,
    SvgOnboardingIconComponent,
    SvgIconCloseChatNotificationAction,
    SvgIconEnlargeComponent,
    SvgIconMinusComponent,
    SvgIconMoreComponent,
    SvgIconMoreChatComponent,
    SvgIconSearchComponent,
    SvgIconVoiceCallComponent,
    SvgIconPauseVideoComponent,
    SvgIconPhoneCallAction,
    SvgIconDeviceBusy,
    SvgIconTextComponent,
    SvgIconVoiceComponent,
    SvgIconVideoComponent,
    SvgIconMicOffComponent,
    SvgIconMicOnComponent,
    SvgIconVideoOffComponent,
    SvgIconVideoOnComponent,
    SvgIconHoldAndCallComponent,
    SvgIconInfoComponent,
    SvgIconChatComponent,
    SvgIconWarning,
    SvgIconClockComponent,
    SvgIconEndSessionComponent,
    SvgIconDeviceAndroidActiveTableComponent,
    SvgIconXsightWelcome,
    SvgIconConfigError,
    SvgIconChartsDemoPage,
    SvgSotixsightHorizontalLogoComponent,
    SvgIconApplicationShift,
    SvgIconApplicationListComponent,
    SvgIconIMDeleteNewComponent,
    SvgIconDownloadLightComponent,
    SvgIconDownloadDarkComponent,
    SvgIconWifiComponent,
    SvgIconNoDataAddedComponent,
    SvgIconDocumentComponent,
    SvgIconColumnViewComponent,
    SvgIconAddNewComponent,
    SvgIconDeleteComponent,
    SvgIconCopyComponent,
    SvgIconEditComponent,
    SvgIconTestConnectionComponent,
    SvgFetchDataErrorComponent,
    SvgIconRefreshComponent,
    SvgIconLinkComponent,
    SvgIconNoMapFoundComponent,
    SvgIconHelpComponent,
    SvgIconCancelSquareComponent,
    SvgIconWebAppListComponent,
    SvgIconWebAppComponent,
    SvgIconDeviceWebAppComponent,
    SvgIconDeviceNetworkComponent,
    SvgIconChatNavigationComponent,
    SvgIconDesktopActiveComponent,
    SvgIconDesktopInactiveComponent,
    SvgIconDeviceWindowsActiveComponent,
    SvgIconDeviceWindowsInactiveComponent,
  ],
  exports: [
    SvgIconAddConditionComponent,
    SvgIconArrowComponent,
    SvgIconAppComponent,
    SvgIconApplication,
    SvgIconApplicationShift,
    SvgIconApplicationListComponent,
    SvgIconAllSmartBatteries,
    SvgIconDataUsage,
    SvgIconBatteryUsage,
    SvgIconLastKnownLocation,
    SvgIconSignalStrength,
    SvgIconDeviceWifi,
    SvgIconDeviceList,
    SvgIconDropdown,
    SvgIconCalendar,
    SvgIconWatchList,
    SvgIconCharts,
    SvgIconCog,
    SvgIconRemoteControl,
    SvgIconNewRemoteControl,
    SvgIconNewTicket,
    SvgIconDeviceAndroidOpaqueComponent,
    SvgIconDeviceAndroidForWork,
    SvgIconDeviceId,
    SvgIconManageShiftComponent,
    SvgIconMessageNotDelivered,
    SvgIconCheckIn,
    SvgIconDeviceDecommission,
    SvgIconDeviceRecommission,
    SvgIconSbImportComponent,
    SvgIconCsv,
    SvgIconDeviceAndroidActiveComponent,
    SvgIconDeviceAndroidInactiveComponent,
    SvgIconDeviceAndroidActiveWhiteComponent,
    SvgIconCsv,
    SvgIconBatterySummary,
    SvgIconClose,
    SvgIconCallAction,
    SvgIconCallFailed,
    SvgIconVideoCallComponent,
    SvgIconRcAction,
    SvgIconCreateIncidentAction,
    SvgIconEndChatAction,
    SvgIconChatTitleComponent,
    SvgIconChatActionComponent,
    SvgIconArrowDownComponent,
    SvgIconChatNofiticationActionComponent,
    SvgIconMicOffActionComponent,
    SvgIconMicOnActionComponent,
    SvgIconMinimize,
    SvgIconVideoOnActionComponent,
    SvgIconVideoOffActionComponent,
    SvgIconScreenOnComponent,
    SvgIconScreenOffComponent,
    SvgIconCallHoldOffComponent,
    SvgIconCallHoldOnComponent,
    SvgIconCallHangupComponent,
    SvgIconCallFullScreenComponent,
    SvgIconCallCloseFullScreenComponent,
    SvgIconCallRejected,
    SvgIconDeviceUserAction,
    SvgIconDeviceUserNotSpeaking,
    SvgIconDeviceUserSpeaking,
    SvgIconChatSendMessageComponent,
    SvgErrorImageComponent,
    SvgOnboardingIconComponent,
    SvgIconCloseChatNotificationAction,
    SvgIconEnlargeComponent,
    SvgIconMinusComponent,
    SvgIconMoreComponent,
    SvgIconMoreChatComponent,
    SvgIconSearchComponent,
    SvgIconVoiceCallComponent,
    SvgIconPauseVideoComponent,
    SvgIconPhoneCallAction,
    SvgIconDeviceBusy,
    SvgIconTextComponent,
    SvgIconVoiceComponent,
    SvgIconVideoComponent,
    SvgIconMicOffComponent,
    SvgIconMicOnComponent,
    SvgIconVideoOffComponent,
    SvgIconVideoOnComponent,
    SvgIconHoldAndCallComponent,
    SvgIconInfoComponent,
    SvgIconChatComponent,
    SvgIconWarning,
    SvgIconClockComponent,
    SvgIconEndSessionComponent,
    SvgIconDeviceAndroidActiveTableComponent,
    SvgIconXsightWelcome,
    SvgIconConfigError,
    SvgIconChartsDemoPage,
    SvgIconDeviceAndroidActiveTableComponent,
    SvgSotixsightHorizontalLogoComponent,
    SvgIconIMDeleteNewComponent,
    SvgIconDownloadLightComponent,
    SvgIconDownloadDarkComponent,
    SvgIconWifiComponent,
    SvgIconNoDataAddedComponent,
    SvgIconDocumentComponent,
    SvgIconColumnViewComponent,
    SvgIconAddNewComponent,
    SvgIconDeleteComponent,
    SvgIconCopyComponent,
    SvgIconEditComponent,
    SvgIconTestConnectionComponent,
    SvgFetchDataErrorComponent,
    SvgIconRefreshComponent,
    SvgIconLinkComponent,
    SvgIconNoMapFoundComponent,
    SvgIconHelpComponent,
    SvgIconCancelSquareComponent,
    SvgIconWebAppListComponent,
    SvgIconWebAppComponent,
    SvgIconDeviceWebAppComponent,
    SvgIconDeviceNetworkComponent,
    SvgIconChatNavigationComponent,
    SvgIconDesktopActiveComponent,
    SvgIconDesktopInactiveComponent,
    SvgIconDeviceWindowsActiveComponent,
    SvgIconDeviceWindowsInactiveComponent,
  ],
})
export class SvgIconsModule {}
